

import TiwiMixin from '../mixins/TiwiMixin';
import CommentCard from './CommentCard';
import CommentField from './CommentField';

export default {
  mixins: [TiwiMixin],
  components: {
    CommentCard,
    CommentField
  },
  props: {
    relatedId: {
      required: true,
      type: Number,
    },
    onLoaded: {
      required: false,
      type: Function,
      default: () => {}
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      comments: [],
    }
  },
  mounted: function () {
    this.getComments();
  },
  methods: {
    getComments: function () {
      var self = this;
      self.setLoading(true);

      var post_data = {
        related_type: 'post',
        related_id: this.relatedId,
      };

      this.api.post('comment/getPostList', post_data)
        .then((response) => {
          if (response.data.success) {
            self.onLoaded();
            self.comments = response.data.comments;
          }
          else {
            self.toast.error(response.data.message);
          }

        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
        .finally(() => self.setLoading(false))
    },
    submitComment: function () {
      this.getComments();
    }
  },
  watch: {
    relatedId: function (new_val, old_val) {
      this.getComments();
    },
  },
}
